import { isEmpty } from 'lodash';
import { CatalogPhotoThumbnail } from 'constants/catalog';

const getDominantColor = photos => {
  if (isEmpty(photos)) return null;
  const photo = photos.find(_ref => {
    let {
      is_main
    } = _ref;
    return is_main === true;
  });
  if (!photo) return null;
  return photo.dominant_color_opaque;
};

const getPhotoThumbnail = (photo, size) => {
  const thumbnails = photo.thumbnails || [];
  const thumbnail = thumbnails.find(_ref2 => {
    let {
      type
    } = _ref2;
    return type === size;
  });
  if (!thumbnail) return null;
  return thumbnail.url;
};

const getCatalogPhotoSrc = photo => {
  const targetSrc = photo.thumbnails.find(_ref3 => {
    let {
      type
    } = _ref3;
    return type === CatalogPhotoThumbnail.Thumb24;
  });
  const retinaSrc = photo.thumbnails.find(_ref4 => {
    let {
      type
    } = _ref4;
    return type === CatalogPhotoThumbnail.Thumb48;
  });
  const src = (targetSrc === null || targetSrc === void 0 ? void 0 : targetSrc.url) || photo.url;
  if (!targetSrc || !retinaSrc) return {
    src
  };
  return {
    src,
    srcset: "".concat(src, " 1x, ").concat(retinaSrc.url, " 2x")
  };
};

export { getDominantColor, getPhotoThumbnail, getCatalogPhotoSrc };